module.exports = __webpack_public_path__ + "img/logo.aaf221c.svg";